import React from "react";
import { Nav, NavbarBrand, Media } from "reactstrap";
import logo from "../../../assets/wembii-logo.png";
import logoWhite from "../../../assets/wembii-logo-white.png";
import { useBreakpointBelowLg } from "../../../hooks/useBreakpointBelowLg";
import { useGlobalCore } from "../../../cores/globals";

import SidebarProtectorRoutes from "./SidebarProtectorRoutes";

const SidebarNavigation = () => {
  const { setOpenSideBar, isDarkMode } = useGlobalCore();
  const isMobileSidebar = useBreakpointBelowLg();

  return (
    <Nav vertical>
      <NavbarBrand
        href="/social"
        className="m-0 d-flex justify-content-center sidebar-brand-logo"
        onClick={() => {
          if (isMobileSidebar) setOpenSideBar(false);
        }}
      >
        <Media
          className="sidebar-logo-img"
          object
          src={isDarkMode ? logoWhite : logo}
          alt="Wembii"
        />
      </NavbarBrand>
      <hr className="horizontal-separator my-2" />
      <SidebarProtectorRoutes />
    </Nav>
  );
};

export default SidebarNavigation;
